<template>
  <v-data-table
    :headers="tableHeaders"
    :items="installments"
    :sort-by="'code'"
    class="elevation-1"
    :hide-default-footer="true"
    :disable-pagination="true"
    mobile-breakpoint="960"
  >

    <template v-slot:item.originalValue="{ item }">

      <MaskedTextField
        :inputData.sync="item.originalValue"
        mask-type="currency"
        label="Valor"
        prefix="R$"
        @update:inputData="recalculateInstallmentsTotal"
        :rules="[requiredRule, minRequiredRule]"
        :disabled="readOnly"
      />

    </template>

    <template v-slot:item.dueDate="{ item }">
      <DateField
        :inputData.sync="item.dueDate"
        :label="'Data da Parcela ' + item.code"
        :key="item.dueDate"
        :rules="[requiredRule]"
        :disabled="readOnly"
      />
    </template>

    <template slot="body.append">
      <tr class="d-none d-md-table-row">
        <td><strong class="title">Total</strong></td>
        <td class="text-xs-left title"><strong :class="installmentsTotal == paymentTotal ? 'green--text' : 'red--text' ">{{ this.installmentsTotal | formatCurrency }}</strong></td>
        <td></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total</div>
          <div class="v-data-table__mobile-row__cell"><strong :class="installmentsTotal == paymentTotal ? 'green--text' : 'red--text' ">{{ this.installmentsTotal | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </v-data-table>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import DateField from "@shared_components/date_field.vue"
import MaskedTextField from "@shared_components/masked_text_field.vue"
// import New from "./new.vue";
// import Edit from "./edit.vue";
// import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      renderComponent: true,
      tableHeaders: [
        { text: "#", align: "left", sortable: true, value: "code" },
        { text: "R$", align: "left", sortable: true, value: "originalValue" },
        { text: "Data", align: "left", sortable: true, value: "dueDate" },
        { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true},
      ],
      maskFields: [
        { field: 'originalValue', mask: 'currency'},
        { field: 'dueDate', mask: 'date'},
      ],
      installmentsTotal: null
    };
  },
  components: {
    BaseIndex: BaseIndex,
    DateField: DateField,
    MaskedTextField: MaskedTextField,
    // New: New,
    // Edit: Edit,
    // Delete: Delete,
  },
  props: {
    installments: {
      type: Array
    },
    paymentTotal: {
      type: Number
    },
    readOnly: {
      type: Boolean,
      default: false
    },
  },
  created() {
    // console.log("installments ", this.installments);
    this.recalculateInstallmentsTotal();
  },
  watch: {
    installments: function(){
      this.recalculateInstallmentsTotal();
    }
  },
  methods: {
    recalculateInstallmentsTotal: function() {
      this.installmentsTotal = 0;
      for (var installment in this.installments) {
        if (!this.installments[installment]._destroy) {
          this.installmentsTotal += this.installments[installment].originalValue ? this.installments[installment].originalValue : 0;
        }
        this.installments[installment].value = this.installments[installment].originalValue;
      }
      this.installmentsTotal = _.round(this.installmentsTotal, 2);
    }
  }
};
</script>

<style scoped></style>
